export default {
  MfaHeading__HEADING: "Security Checkpoint",
  MfaHeading__SUBHEADING:
    "In order to keep your account secure, we need to verify your identity before you proceed.",
};
